import { boolean, InferType, object } from "yup";

export const roadmapVisibilityConditionsSchema = object({
  isMDR: boolean().optional(),
  isIVDR: boolean().optional(),
  isFDA: boolean().optional(),
  hasHardware: boolean().optional(),
  hasSoftware: boolean().optional(),
  hasElectricalComponent: boolean().optional(),
  isClass1: boolean().optional(),
  isClass2a: boolean().optional(),
  isClass2b: boolean().optional(),
  isClass3: boolean().optional(),
});

export type RoadmapVisibilityConditions = InferType<
  typeof roadmapVisibilityConditionsSchema
>;
